import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles({ name: 'IconsStyle' })(_ => ({
  icon: {
    width: 24,
    height: 24,
    // Inherit color from the parent (e.g. MUI's `color` prop/sx),
    // so the icon adapts to the active theme (light/dark) just like
    // regular MUI icons, instead of always rendering black.
    fill: 'currentColor',
  },
}));
